import { Task } from "@freeconvert/freeconvert-node/dist/types";

export const getFileNameFromTask = (task: Task) =>
    task.result?.url?.toString() ? task.result.url.toString().split("/").at(-1) || "" : "";
